import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { spacing, fontSize } from '../../lib/theme';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import AppCustomLink from './AppCustomLink';
import ScrollContainer from 'react-indiana-drag-scroll';

export default class AppSideScroll extends Component {
    constructor(props) {
        super(props);
        this.state = { prevInactive: true, nextInactive: false, scrollWidth: undefined };
        this.myRef = React.createRef();
    }

    componentDidMount() {
        this.setActiveState();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.children !== this.props.children) {
            this.setActiveState();
        }
    }

    setActiveState() {
        if (Math.abs(this.myRef.current.scrollWidth - this.myRef.current.offsetWidth) < 10) {
            this.setState({ nextInactive: true });
        } else {
            this.setState({ nextInactive: false });
        }
    }

    sideScroll = (element, direction, speed, distance, step) => {
        let maxScrollWidth = element.scrollWidth - (element.clientWidth / 2) - (element.offsetWidth / 2);
        console.log(maxScrollWidth);
        let scrollAmount = 0;
        console.log('distance : ' + distance);
        var slideTimer = setInterval(() => {
            if (direction == 'left') {
                element.scrollLeft -= step;
            } else {
                element.scrollLeft += step;
            }
            scrollAmount += step;
            if (scrollAmount >= distance) {
                console.log(element.scrollLeft);
                if (element.scrollLeft > maxScrollWidth - 10) {
                    this.setState({ prevInactive: false, nextInactive: true });
                } else if (element.scrollLeft < 10) {
                    this.setState({ prevInactive: true, nextInactive: false });
                } else {
                    this.setState({ prevInactive: false, nextInactive: false });
                }
                console.log('prevInactive : ' + this.state.prevInactive);
                window.clearInterval(slideTimer);
            }
        }, speed);
    }

    scrollHorizontal = (direction) => {
        // window.scrollTo({top: 0, left: 200, behavior: 'smooth' });
        let distance = 0.6 * this.myRef.current.offsetWidth + 10; // + this.myRef.current.scrollLeft + 10;
        // this.myRef.current.scrollLeft = distance;
        this.sideScroll(this.myRef.current, direction, 20, distance, Math.floor(distance / 12));
    }

    render() {
        const { children, title, showScroll, seeAllText, seeAllLink, titleWidget, loadingWidget } = this.props;
        // const { prevInactive, nextInactive } = this.state;
        console.dir(seeAllLink);
        return <>
            <Row>
                <Col span={16}>
                    {titleWidget || <h3 style={{ fontWeight: '700', marginBottom: 0 }}>{title}</h3>}
                </Col>
                {showScroll &&
                    <Col span={8} style={{ textAlign: 'right' }}>
                        {seeAllText && <div style={{ display: 'inline-block', transform: 'translate(-8px, -2px)' }}><AppCustomLink href={seeAllLink}>{`${seeAllText}  `}</AppCustomLink></div>}
                        <a onClick={this.scrollHorizontal.bind(this, 'left')}>
                            <LeftOutlined
                                style={{ 'fontSize': `${fontSize('lg')}` }} /></a>
                        <a onClick={this.scrollHorizontal.bind(this, 'right')}>
                            <RightOutlined
                                style={{ 'fontSize': `${fontSize('lg')}` }} /></a>
                    </Col>}
            </Row>
            <hr className='separator' />
            {loadingWidget}
            <ScrollContainer innerRef={this.myRef} className="scroll-container" style={{ display: 'flex', overflowX: 'hidden', marginTop: `${spacing('')}`, paddingTop: '4px' }}>
                {/* <div ref={this.myRef} style={{ display: 'flex', overflowX: 'hidden', marginTop: `${spacing('')}` }}> */}
                {/* {children} */}
                {children}
                {/* </div> */}
            </ScrollContainer>
        </>;
    }
}
AppSideScroll.defaultProps = {
    showScroll: true,
    seeAllText: '',
    seeAllLink: ''
}
AppSideScroll.propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.element]),
    title: PropTypes.string,
    titleWidget: PropTypes.element,
    loadingWidget: PropTypes.element,
    seeAllLink: PropTypes.string,
    seeAllText: PropTypes.string,
    showScroll: PropTypes.bool,
}
